import React from "react";
import { FORMATION_LABELS, formatDate } from "./constants";

export default function ContactList({ items, selectedId, onSelect }) {
  return (
    <div className="space-y-3">
      {items.map((it) => (
        <button
          key={it.id}
          onClick={() => onSelect(it)}
          className={`w-full text-left bg-white rounded-xl border p-4 transition-all hover:shadow-md ${
            selectedId === it.id
              ? "border-[#e8a04d] shadow-md ring-2 ring-[#e8a04d]/20"
              : "border-[#e6ded0]"
          }`}
          data-testid={`admin-contact-item-${it.id}`}
        >
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <div className="font-semibold text-[#0e3a3f] truncate">
                {it.firstName} {it.lastName}
              </div>
              <div className="text-xs text-[#2c7a80] mt-0.5 truncate">
                {FORMATION_LABELS[it.formation] || it.formation || "Formation non précisée"}
              </div>
            </div>
            <span className="text-[11px] text-[#0e3a3f]/50 whitespace-nowrap">
              {formatDate(it.created_at)}
            </span>
          </div>
          <p className="text-sm text-[#0e3a3f]/70 mt-2 line-clamp-2">{it.message}</p>
        </button>
      ))}
    </div>
  );
}
